<template>
	<div class="autherBox">
		<!-- 我的 -->
		<div class="userMiddleBox_big">
			
			<van-sticky>
				<!-- 头部 -->
				<div class="fixedHeaderImg" v-if="height_scroll <10">
					<img src="../../assets/img/auterZl_bgc.png" alt="" class="myimgbgc">
					<!-- @click="jumpUrl" -->
					<div class="leftarr_tit" @click="jumpUrl()">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="col_nameBox">{{authorData.col_name}}</p>
					<div class="massageNum" @click="jumpMyYS">
						<span class="num">我的云书</span>
					</div>
				</div>
				<!-- 头部 -->
				<div class="headerBox" v-if="height_scroll >=10" style="background-color: #fff !important;"> 
					<div class="headerQuery">
						<div class="arrImg" @click="jumpUrl()">
							<img src="../../assets/img/leftarr_tit.png" alt="">
						</div>
						<p class="header_titile">{{authorData.col_name}}</p>
						<!-- <div>
							<div class="massageNum01" @click="jumpMyYS">
								<span class="num">我的云书</span>
							</div>
						</div> -->
					</div>
				</div>
			</van-sticky>
			<!-- 用户头像 -- id   -->
			<div class="fixedBox">
				<div class="yunshuBox_navbar">
					<div class="yunshuNavbar_top">
						<img :src="authorData.col_avatar" alt="" class="headerImg">
						<div class="yunshuNavbar_top_left">
							<!-- ({{authorData.col_name}}) 专栏名称 -->
							<div class="yunjin_txt"><i>{{authorData.nickname}}</i>
								<img src="../../assets/img/bookinfoIcon.png" alt="" class="bookinfoIcon" v-if="authorData.is_vip == 3 ? true : false" />
								<a class="margi_lef" v-if="authorData.is_vip == 3 ? true : false"></a>
								<span @click="shoucangFn_qx" v-if="authorData.is_collect == 1" class="celShowSc">
									<img src="../../assets/img/iocn6.png" alt="" class="iocn6">
									取消收藏
								</span>
								<span @click="shoucangFn" v-else>
									<img src="../../assets/img/iocn6.png" alt="" class="iocn6">
									收藏
								</span>
							</div>
							<div class="scNum">
								<span v-model="collect_numSc">{{collect_numSc}}</span>
								<p>收藏数</p>
							</div>
						</div>
						<div class="jianjie" v-html="authorData.col_describe"></div>
						<div class="jiangbeiImg">
							<span v-for="index in authorData.lianzai_num">
								<img src="../../assets/img/jiangbei.png" alt="">
							</span>
							<span v-for="index in authorData.wanjie_num">
								<img src="../../assets/img/jiangbei01.png" alt="">
							</span>
							<span v-for="index in authorData.zhanting_num">
								<img src="../../assets/img/jiangbei02.png" alt="">
							</span>
						</div>
					</div>
					<div class="yunshuNavbar_bottom">
						<h4>最近更新</h4>
						<div class="yunshuNavbar_flex">
							<div class="left" @click="jumpBookinfo(chapterData.id,chapterData.books_status)">
								<img src="../../assets/img/new.png" alt="">
								<span class="bookName">《{{chapterData.name}}》</span>
								<span><span>第{{chapterData.number}}章</span><span class="paddLeft">{{chapterData.chapter_synopsis}}</span></span>
							</div>
							<!-- <div class="right"><span>{{chapterData.createtime}}</span></div> formatDateTime -->
							<div class="right"><span>{{chapterData. updatetime}}</span></div> 
						</div>
					</div>
				</div>
			</div>

			<!-- 列表 -->
			<div class="xl_list">
				<div class="blockBox" v-for="(item,idx) in booksData" :key="idx">
					<h4>{{item.list_name}}</h4>
					<div class="blockLeft" v-for="(bookItm,index) in item.list" :key="index" @click="jumpBookinfo(bookItm.books_id,bookItm.lock_status)">
						<div class="book_Img">
							<img :src="$api.$BASE_URL_img + bookItm.cover_image" alt="" />
						</div>
						<div class="blockBookInfo">
							<div class="bookName">
								<van-notice-bar scrollable :text="bookItm.name"></van-notice-bar>
								<img v-if="bookItm.lock_status == 0? true : false" src="../../assets/img/ml_activeJs.png" alt="">
								<img v-if="bookItm.lock_status == 2? true : false" src="../../assets/img/ml_wjs.png" alt="">
								<p><span>{{Math.floor((bookItm.total_words / 10000) * 100) / 100}}万字</span><span>{{bookItm.progress_status}}</span></p>
							</div>
							<p class="bookType">{{bookItm.original_list + '&nbsp;-&nbsp;' + bookItm.appetency_list + '&nbsp;-&nbsp;' + bookItm.epoch_list + '&nbsp;-&nbsp;' + bookItm.type_list}}</p>
							<div class="introduction"><span v-for="(item,idx) in bookItm.introduce" v-if="idx<=14">{{item}}</span></div>
							<div class="introduction">
								<p>发表时间：{{bookItm.createtime}}</p>
							</div>
							<div class="book_button">
								<button v-for="(lableItm,lableIdx) in bookItm.lable_list" :key="lableIdx">{{lableItm.name}}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant'
	export default {
		data() {
			return {
				isRouterAlive: true,
				bookpageUrl: '',
				book_id: '',
				authorData: {},
				chapterData: [],
				booksData: [],
				showSc: true,
				collect_numSc: 0,
				user_id: '',
				active: '',
				height_scroll: 0,
			}
		},
		created() {
			this.bookpageUrl = this.$route.query.bookpageUrl;
			this.cityPage = this.$route.query.url;
			this.book_id = this.$route.query.book_id || this.$route.query.id;
			this.user_id = this.$route.query.user_id;
			this.getAuthorInfo(); //获取作者专栏

			if (this.$route.query.active) {
				this.active = this.$route.query.active;
			}
		},
		methods: {
			jumpUrl() {
				if (this.cityPage == 'zzzl' && this.active == 2) {
					this.$router.push({
						path: '/bookshelf',
						query: {
							com_name: 'cp',
							active: 2
						}
					})
				} else {
					this.$router.go(-1);
				}
			},
			jumpUrldzzhuanlan() {
				// this.$router.push('/dzzhuanlan')
				if (this.bookpageUrl == 'bookpageUrl') {
					this.$router.push({
						path: '/bookinfo',
						query: {
							id: this.book_id
						}
					})
				}
			},
			jumpMyYS() {
				this.$router.push({
					path: '/dzzhuanlan',
					query: {
						url: this.cityPage,
						id: this.book_id,
						index: this.$route.query.index,
						active: this.$route.query.active,
						user_id: this.user_id
					}
				})
			},
			getAuthorInfo() {
				// user_id: 63
				this.$axios.post(`${this.$api.author_info}?user_id=${this.user_id}`).then(res => {
					console.log(res)
					this.authorData = res.data.data.user; //作者信息
					this.chapterData = res.data.data.chapter; //最近更新
					this.booksData = res.data.data.books;
					this.collect_numSc = res.data.data.user.collect_num;
					
					
					this.authorData.col_avatar
					if (this.authorData.col_avatar.indexOf("https://thirdwx.qlogo.cn/") != -1) {
						this.authorData.col_avatar =this.authorData.col_avatar;
					} else if(this.authorData.col_avatar.indexOf("http://thirdqq.qlogo.cn/") != -1){
						this.authorData.col_avatar = this.authorData.col_avatar;
					}else {
						this.authorData.col_avatar = `${this.$api.$BASE_URL_img}${this.authorData.col_avatar}`;
					}
					console.log(this.booksData)
				})
			},
			jumpBookinfo(id,lock_status) {
				// 全文锁定:1=解锁,0=管理员锁定 ,2作者锁
				if(lock_status == 1){
					this.$router.push({
						path: '/bookinfo',
						query: {
							id: id,
							url: 'zzzlPage',
							active: this.$route.query.active
						}
					})
				}else if(lock_status == 0){
					Toast('本书已被后台管理员锁定')
				}else if(lock_status == 2){
					Toast('本书已被作者锁定')
				}
			},
			// 收藏
			shoucangFn() {
				this.$axios.post(`${this.$api.collect_author}?user_id=${this.user_id}`).then(res => {
					console.log(res)
					Toast(res.data.msg);
					this.getAuthorInfo(); //获取作者专栏
				})
			},
			// 取消收藏
			shoucangFn_qx() {
				this.$axios.post(`${this.$api.cancel_collect}?user_id=${this.user_id}`).then(res => {
					console.log(res)
					Toast(res.data.msg);
					this.getAuthorInfo(); //获取作者专栏
				})
			},
			handleScroll() {
				this.height_scroll = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
				console.log(this.height_scroll, 'height_scroll');
			},
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll) //  离开页面清除（移除）滚轮滚动事件
		}
	}
</script>
<style>
	.van-dialog__confirm,
	.van-dialog__confirm:active {
		color: #ff4081;
	}
</style>
<style lang="less" scoped>
	.autherBox {
		background-color: #f9f9f9;
		height: 100vh;
		position: relative;
		// overflow: scroll;
		color: #000;

		// 头部
		.headerBox {
			height: 160px;
			background-color: #fff;
			display: flex;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 50px;
				padding: 0 0px;
				position: relative;
				// display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
				z-index: 100;

				.backImg {
					position: absolute;
					bottom: 10px;
					left: 0;
					width: 100%;
				}

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
						z-index: 99;
					}
				}

				.titleNew {
					width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					word-break: break-word;
					line-clamp: 1;
					-webkit-line-clamp: 1;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					text-align: center;
					position: absolute;
					top: 0;
					left: 0;
					font-size: 34px;
				}

				.header_titile {
					// flex: 1;
					position: absolute;
					left: 50px;
					// top: 60px;
					font-size: 30px;
					/*px*/
					img {
						width: 40px;
						vertical-align: middle;
					}
				}
				//我的云书
				.massageNum01 {
					position: absolute;
					right: 30px;
					font-size: 30px;
					/*px*/
				}
			}

		}
	}

	.userMiddleBox_big {
		// background-color: #f9f9f9;
		height: 100vh;
		// position: relative;
		// overflow: hidden;
		// color: #000;
		// overflow: scroll;

		.myimgbgc {
			width: 100vw;
			position: fixed;
			top: 0;
			left: 0;
		}

		.fixedHeaderImg {
			width: 100vw;
			height: 388px;
			background-color: transparent;
			border-bottom-left-radius: 45px;
			border-bottom-right-radius: 45px;
			position: fixed;
			top: 0;
			z-index: 101;
		}

		.leftarr_tit {
			img {
				width: 40px;
				position: absolute;
				top: 60px;
				left: 0px;
			}
		}

		.col_nameBox {
			position: absolute;
			top: 60px;
			left: 60px;
			font-size: 30px;
			/*px*/
		}

		//我的云书
		.massageNum {
			position: absolute;
			top: 60px;
			right: 30px;
			font-size: 30px;
			/*px*/
		}

		.fixedBox {
			// border-bottom: 8px solid #f0f0f0;
			// /*no*/
			width: 100vw;
			// position: absolute;
			z-index: 110;
			// top: 166px;
			// left: 0;
			padding-bottom: 20px;
			position: relative;
			margin-top: 180px;
			.yunshuBox_navbar {
				padding: 20px;
				padding-bottom: 20px;
				width: calc(100vw - 80px);
				margin: 0 auto;
				border-radius: 20px;
				background-color: #fff;
				-webkit-box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);
				/*no*/
				-moz-box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);
				/*no*/
				box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);

				/*no*/
				.yunshuNavbar_top {
					border-bottom: 1px solid #f0f0f0;

					/*no*/
					.headerImg {
						position: absolute;
						top: -40px;
						left: 50px;
						width: 120px;
						height: 120px;
						border-radius: 50%;
						background-color: #fff;
						-webkit-box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0 0 3px 0 rgba(0, 0, 0, .3);
						/*no*/
					}

					.yunshuNavbar_top_left {
						position: relative;

						.yunjin_txt {
							height: 40px;
							margin-left: 144px;
							position: relative;

							i {
								font-style: normal;
								font-size: 30px;
								/*px*/
								line-height: 40px;
								display: inline-block;
								padding-right: 10px;
							}

							.bookinfoIcon {
								vertical-align: top;
								width: 30px;
								padding-left: 10px;
								position: absolute;
								top: 50%;
								transform: translateY(-50%);
							}

							.margi_lef {
								margin-right: 60px;
							}

							span {
								display: inline-block;
								width: 100px;
								height: 40px;
								line-height: 40px;
								border-radius: 40px;
								background-color: #ffebee;
								text-align: center;
								color: #fa7089;
								position: relative;

								.iocn6 {
									position: absolute;
									top: -5px;
									left: -5px;
									width: 30px;
								}
							}

							.celShowSc {
								width: 160px;
							}
						}

						.scNum {
							position: absolute;
							top: 0px;
							right: 0;
							text-align: center;
						}
					}

					.jianjie {
						line-height: 50px;
						font-size: 26px;
						/*px*/
						margin-top: 40px;
						padding-left: 10px;
						color: #9a9a9a;
						height: 100px;
						overflow: hidden;
					}

					.jiangbeiImg {
						padding-top: 20px;
						padding-bottom: 20px;
						padding-left: 20px;

						img {
							margin-right: 10px;
							width: 50px;
						}
					}
				}

				.yunshuNavbar_bottom {
					padding-top: 10px;
					padding-bottom: 20px;

					h4 {
						line-height: 60px;
						font-size: 28px;
						/*px*/
						padding-bottom: 10px;
					}

					.yunshuNavbar_flex {
						display: flex;
						position: relative;
						height: 60px;
						line-height: 60px;
						overflow: hidden;

						img {
							position: absolute;
							top: 50%;
							transform: translateY(-50%);
							left: 0px;
							width: 50px;
							vertical-align: middle;
							padding-right: 10px;
						}

						.bookName {
							margin-left: 50px;
						}

						>span {
							flex: 1;
							padding-right: 15px;
							// display: inline-block;
							// width: 100px;
							overflow: hidden;

							color: #3d3d3d;
						}

						>span:last-child {
							padding-right: 0;
						}

						div.left {
							width: 60%;
							overflow: hidden;
						}

						div.right {
							width: 240px;
							color: #a3a3a3;
							position: absolute;
							right: 0;
							top: 50%;
							transform: translateY(-50%);
						}

						.paddLeft {
							padding-left: 5px;
						}
					}
				}
			}
		}

		.xl_list {
			margin-top: 0px;
			// height: calc(100vh - 650px);
			// overflow-x: hidden;
			// overflow-y: scroll;

			//列表数据
			.blockBox {
				position: relative;
				background-color: #fff;
				padding: 0px 16px;
				border-bottom: 8px solid #f0f0f0;

				/*no*/
				h4 {
					line-height: 60px;
					padding-top: 20px;
					font-size: 30px;
					/*px*/
				}

				.blockLeft {
					display: flex;
					background-color: #fff;
					padding: 20px 0px;
					padding-bottom: 20px;
					border-bottom: 1px solid #f0f0f0;

					/*no*/
					.book_Img {
						img {
							width: 180px;
							height: 270px;
							display: block;
							float: left;
							-webkit-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
							/*no*/
							-moz-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
							/*no*/
							box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
							/*no*/
						}
					}

					.blockBookInfo {
						margin-left: 20px;
						flex: 1;
						font-size: 26px;
						/*px*/
						line-height: 30px;

						.auther {
							color: #000;
							font-size: 26px;
							/*px*/
							opacity: 0.6;
						}

						.auther {
							color: #000;
							opacity: 0.6;
							font-size: 26px;
							/*px*/
							padding-top: 10px;
						}

						.bookType,
						.introduction {
							padding-top: 10px;
							color: #000;
							opacity: 0.4;
							font-size: 24px;
							/*px*/
						}

						.bookName {
							font-size: 30px;
							/*px*/
							color: #000000;
							font-weight: normal;
							width: 500px;
							height: 40px;
							line-height: 40px;
							overflow: hidden;
							overflow-x: scroll;
							position: relative;

							.van-notice-bar {
								color: #000;
								padding: 0;
								background-color: #fff;
								height: 40px;
								line-height: 40px;
								width: calc(100vw - 460px);

								.van-notice-bar__wrap {
									height: 40px;
									line-height: 40px;
								}
							}
							img{
								position: absolute;
								top: 50%;
								right: 40%;
								transform: translateY(-50%);
								height: 30px;
								background-color: #fff;
							}
							>p {
								position: absolute;
								top: 50%;
								right: 0px;
								transform: translateY(-50%);
								font-weight: 400;

								span {
									margin-left: 8px;
									color: #000;
									opacity: 0.6;
									font-size: 26px;
									/*px*/
								}
							}
						}

						.introduction {
							width: 60vw;
							padding-top: 15px;

							p {
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
							}
						}

						.book_button {
							margin-top: 15px;

							button {
								outline: none;
								border: 0;
								border: 1px solid #fec6d5;
								/*no*/
								border-radius: 28px;
								padding: 0px 20px;
								display: inline-block;
								// line-height: 40px;
								background-color: #fff8fa;
								color: #fa7298;
								margin-right: 20px;
								font-size: 24px;
								/*px*/
								margin-bottom: 10px;
							}

							.active {
								background-color: #fa7298;
								color: #ffffff;
							}
						}
					}
				}

				.blockLeft:last-of-type {
					margin-bottom: 50px;
					border-bottom: 0;
				}
			}

			.blockBox:last-of-type {
				border-bottom: 0;
			}

		}

	}
</style>
